<template>
<div class="text">
<text-block>
<slot></slot>
</text-block>
</div>
</template>

<script>
import TextBlock from '@/components/general/text-block'

export default {
  components: { TextBlock }
}
</script>

<style lang="scss" scoped>
div.text {
  padding: 1rem;
  background-color: white;
  border-radius: 0.25rem;
  border: solid 1px #dddddd;
  line-height: 1.5;
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/components/general/text-view.vue